<template>
   <div class="form-group">
      <label
         for="ip_name"
         :class="['label-overlay', { active: !isNotEmpty(form.name) }]"
         @click="switchLabel($event)"
      >
         Name
      </label>
      <input
         id="ip_name"
         v-model.trim="form.name"
         type="text"
         class="form-control"
         name="name"
         :class="[{ 'is-invalid': isValidName.isInvalid }, { 'is-valid': isValidName.isValid }]"
         @focus="switchLabel($event)"
         @blur="
            switchLabel($event);
            validateNameData();
            initiatedType();
         "
      />
      <div class="invalid-feedback">Who do we say hi to?</div>
      <div class="valid-feedback">Good name.</div>
   </div>
</template>

<script>
import person from '../../../util/userData.js';

export default {
   name: 'NameComponent',
   props: {
      value: {
         type: String,
         default: '',
      },
      options: {
         type: Object,
         default: null,
      },
   },
   data() {
      return {
         isValidName: {
            isInvalid: false,
            isValid: false,
         },
         form: {
            name: this.value,
         },
         ...(process.browser && { userProfileTracker: this.$tracker.userProfile }),
         person,
         ...(process.browser && { tracker: this.$tracker.tracker }),
      };
   },

   mounted() {
      if (this.person.profileData) {
         this.form.name = this.person.profileData.name || '';
      }
   },
   methods: {
      validateNameData() {
         this.isValidName.isInvalid = this.$parent.attemptSubmit && !this.missingName;
         this.isValidName.isValid = this.missingName;
      },

      reset() {
         this.isValidName.isInvalid = false;
         this.isValidName.isValid = false;
         this.form.name = '';
      },

      initiatedType() {
         if (this.form.name !== '') {
            this.userProfileTracker.information({ name: this.form.name });
         }

         if (
            typeof this.$parent.isFormInitiated === 'undefined' &&
            this.options &&
            this.options.mixpanelEve
         ) {
            this.$parent.isFormInitiated = true;

            this.tracker(this.options.mixpanelEve, {
               ...(this.options.name && { Name: this.options.name }),
               ...(this.options.type && { Type: this.options.type }),
               ...(this.options.product && { Product: this.options.product }),
               ...(this.options.framework && { Framework: this.options.framework }),
            });
         }
      },
   },
};
</script>

<style></style>
